import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class FileData {

  constructor(
    private http: HttpClient
  ) { }

  public uploadFile(URL, formData){
    return this.http
    //post the form data to the url defined above and map the response. Then subscribe //to initiate the post. if you don't subscribe, angular wont post.
    .post(URL, formData);
  }
}
 // end file



// WEBPACK FOOTER //
// ./src/providers/file.ts